var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestScore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 502 502",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 10,
    style: {
      fill: "#F0EFE4"
    },
    width: 360,
    height: 482
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 68,
    style: {
      fill: "#F77E65"
    },
    width: 87,
    height: 87
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 349,
    style: {
      fill: "#F77E65"
    },
    width: 87,
    height: 87
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M431,0H71c-5.522,0-10,4.477-10,10v482c0,5.523,4.478,10,10,10h360c5.522,0,10-4.477,10-10V10C441,4.477,436.522,0,431,0z  M421,482H81V20h340V482z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,165h87c5.522,0,10-4.477,10-10V68c0-5.523-4.478-10-10-10h-87c-5.522,0-10,4.477-10,10v87 C116,160.523,120.478,165,126,165z M136,78h67v67h-67V78z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,306h87c5.522,0,10-4.477,10-10v-19c0-5.523-4.478-10-10-10s-10,4.477-10,10v9h-67v-67h62c5.522,0,10-4.477,10-10 s-4.478-10-10-10h-72c-5.522,0-10,4.477-10,10v87C116,301.523,120.478,306,126,306z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,446h87c5.522,0,10-4.477,10-10v-87c0-5.523-4.478-10-10-10h-87c-5.522,0-10,4.477-10,10v87 C116,441.523,120.478,446,126,446z M136,359h67v67h-67V359z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,99h50c5.522,0,10-4.477,10-10s-4.478-10-10-10h-50c-5.522,0-10,4.477-10,10S321.478,99,327,99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,99h17c5.522,0,10-4.477,10-10s-4.478-10-10-10h-17c-5.522,0-10,4.477-10,10S262.478,99,268,99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,140h109c5.522,0,10-4.477,10-10s-4.478-10-10-10H268c-5.522,0-10,4.477-10,10C258,135.523,262.478,140,268,140z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,221h-50c-5.522,0-10,4.477-10,10s4.478,10,10,10h50c5.522,0,10-4.477,10-10S382.522,221,377,221z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,241h17c5.522,0,10-4.477,10-10s-4.478-10-10-10h-17c-5.522,0-10,4.477-10,10S262.478,241,268,241z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,282h109c5.522,0,10-4.477,10-10s-4.478-10-10-10H268c-5.522,0-10,4.477-10,10S262.478,282,268,282z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,360h-50c-5.522,0-10,4.477-10,10s4.478,10,10,10h50c5.522,0,10-4.477,10-10S382.522,360,377,360z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,380h17c5.522,0,10-4.477,10-10s-4.478-10-10-10h-17c-5.522,0-10,4.477-10,10S262.478,380,268,380z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,421h109c5.522,0,10-4.477,10-10s-4.478-10-10-10H268c-5.522,0-10,4.477-10,10S262.478,421,268,421z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.429,275.071c1.953,1.953,4.512,2.929,7.071,2.929s5.118-0.976,7.071-2.929l59.5-59.5 c3.905-3.905,3.905-10.237,0-14.143c-3.906-3.905-10.236-3.905-14.143,0l-52.52,52.52l-18.501-17.678 c-3.991-3.815-10.323-3.672-14.138,0.321c-3.816,3.993-3.672,10.323,0.321,14.139L173.429,275.071z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestScore);
export default __webpack_public_path__ + "static/media/test-score.9bfc700da3d6d4364750d3aea5397abc.svg";
export { ForwardRef as ReactComponent };